export const RIMS_LOCAL_STG_CONSTANTS = {
  LOGIN_TOKEN: "LOGIN_TOKEN",
  USER_INFO: "USER_INFO",
  MENU_AUTH_LIST: "MENU_AUTH_LIST",
  DATA_AUTH_LIST: "DATA_AUTH_LIST",
  SESSION_TIME_OUT: "SESSION_TIME_OUT",
  PRIVILEGES: "PRIVILEGES",
  DATEFORMAT: "DATEFORMAT",
  EMAIL: "EMAIL",
  DISABLE_BACK_PREVIOUS: "DISABLE_BACK_PREVIOUS",
  GLOBAL_LOADING: "GLOBAL_LOADING",
};

export const RIMS_COOKIE_CONSTANTS = {
  USER_TENANT_ID: "USER_TENANT_ID",
  LOGIN_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
  URL_DOMAIN: "URL_DOMAIN",
  DOMAIN: "DOMAIN",
  USER_NAME: "USER_NAME",
  USER_EMAIL: "USER_EMAIL",
  USER_PRIVILEGES: "USER_PRIVILEGES",
  USER_INFO: "USER_INFO",
  AC_TENANT_ID: 'AC_TENANT_ID'
};

export const LANGUAGEMAP: { [key: string]: any } = {
  mui: {
    en: "enUS",
    jp: "jaJP",
  },
};

export const DEFAULT_LANGUAGE = 'en';

export const VALID_LANGUAGES = ['en', 'jp'];

export const enum ModeEnum {
  READ = "read",
  UPDATE = "update",
  CREATE = "create",
}

export const customMenuPath: { [key: string]: string } = {
  // TODO need change
  plantrack_Processes: "/plantrack/processes",
  plantrack_Tasks: "/plantrack/tasks",
  plantrack_Plans: "/plantrack/plans",
  plantrack_Reports: "/plantrack/reports",
  // "registrations_Documents": "/documents",
  // "product_Product_Information": "/product-info",
  // "product_Documents": "/product-documents",
  // "registration_Application_Details": "/app-details",
  // "registrations_Applications": "/app-details",
  // "registrations_ePI": '/ePI',
  // "registrations_IDMP": '/IDMP',
  // "registrations_Commitments": '/commitments',
  // "registrations_Obligations": '/obligations',
  // "registrations_Local_Changes": '/local-changes',
  // "registrations_Submissions": '/submission-details',
  // "registrations_RTQs": '/rtq'
};

export const enum ProcessStatusEnum {
  NOTSTART = "Not Started",
  INPROGRESS = "In Progress",
  COMPLETED = "Completed",
  TERMINATED = "Terminated"
}

export type ProcessStatus = typeof ProcessStatusEnum[keyof typeof ProcessStatusEnum];

export const enum TaskKPIStatus { 
  OVERDUE = "Overdue",
  ONTRACK = "On Track"
}

export const enum TaskStatusEnum {
  UNASSIGNED = "Unassigned",
  NOTSTART = "Not Started",
  INPROGRESS = "In Progress",
  COMPLETED = "Completed",
  TERMINATED = "Terminated"
}

export type TaskStatus = typeof TaskStatusEnum[keyof typeof TaskStatusEnum];

// ForwardType: 
// 0:query process view forward url；
// 1:query my task forward url
// 2:query task list view forward url
// 3:query bulk my task forward url
export const FORWARD_TYPE = {
  PROCESS_List_VIEW: 0,
  MY_TASK_VIEW: 1,
  TASK_LIST_VIEW: 2,
  MY_TASK_BULK_VIEW: 3,
  EVENT_LIST_VIEW: 5
} as const;

export const SYSTEM_DAFAULT_PROPERTY_lIST = ["reTaskId", "reTaskModuleId", "section"]

export const CALL_ACTIVITY_SYSTEM_PROPERTY_LIST = ["moduleId", "callActivityName", "moduleName"];

/** System fields that remain required when saving a task as draft. */
export const SAVE_AS_DRAFT_REQUIRED_FIELDS = [
  "taskOwners",
  "taskRecord",
  "taskRecordSource",
  "newTaskRecord"
];

export const DEFAULT_FLOWABLE_CLASS =
  "com.freyr.pm.flowablecompatible.delegate.DefaultServiceTaskDelegate";

export const FLOWABLENAMESPACE = "http://flowable.org/bpmn";

export const initiationPrivilege = ["own", "initiation"]
export const associationPrivilege = ["own", "association"]
